import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ScenarioDrawerWrapper = styled.div`
  margin: 20px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: var(--border-soft);
  margin: 40px 0;
`;

export const LineBreak = styled.div`
  width: 100%;
  height: 1px;
  margin: 40px 0;
`;

export const Title = styled.h2`
  ${typographyV2.titleLg};
  color: var(--text-default);
`;

export const Subtitle = styled.div`
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;
